import { create } from 'zustand';
type Filters = Record<string, any>;

type FilterState = {
    sortOption: string;
    currentFilters: Filters;
    setSortOption: (option: string) => void;
    clearSortOption: () => void;
    setFilters: (filters: Filters) => void;
    clearFilters: () => void;
};

export const useFilterStore = create<FilterState>((set) => ({
    sortOption: '',
    currentFilters: {},
    setSortOption: (option) => set({ sortOption: option }),
    clearSortOption: () => set({ sortOption: '' }),
    setFilters: (filters) => set({ currentFilters: filters }),
    clearFilters: () => set({ currentFilters: {}, sortOption: '' }),
}));
